export const primary = {
  50: 'oklch(0.982084 0.013244 333.034319)',
  100: 'oklch(0.965669 0.023247 338.610142)',
  150: 'oklch(0.948854 0.03339 337.959274)',
  200: 'oklch(0.93185 0.042831 339.134147)',
  250: 'oklch(0.910705 0.055741 337.314857)',
  300: 'oklch(0.887629 0.069703 336.916306)',
  350: 'oklch(0.86725 0.08373 335.420133)',
  400: 'oklch(0.84582 0.096185 334.510766)',
  450: 'oklch(0.784752 0.136018 335.952916)',
  500: 'oklch(0.723334 0.175513 337.649945)',
  550: 'oklch(0.661983 0.214363 338.632544)',
  600: 'oklch(0.601253 0.254233 340.252307)',
  650: 'oklch(0.536642 0.227232 340.78992)',
  700: 'oklch(0.470462 0.200119 341.098388)',
  750: 'oklch(0.406687 0.174181 341.335872)',
  800: 'oklch(0.340576 0.146851 341.706145)',
  850: 'oklch(0.282424 0.121774 341.71207)',
  900: 'oklch(0.22599 0.097183 342.322886)',
  950: 'oklch(0.168705 0.072287 343.166627)',
}
export const accent = {
  50: 'oklch(0.987839 0.007543 61.45578)',
  100: 'oklch(0.977951 0.014375 64.347922)',
  150: 'oklch(0.965645 0.019381 60.174704)',
  200: 'oklch(0.955039 0.025491 63.743337)',
  250: 'oklch(0.936249 0.041053 64.929124)',
  300: 'oklch(0.917859 0.056636 65.300646)',
  350: 'oklch(0.900675 0.072472 68.034989)',
  400: 'oklch(0.882019 0.087884 68.490482)',
  450: 'oklch(0.829842 0.113933 61.388359)',
  500: 'oklch(0.778954 0.140471 55.166517)',
  550: 'oklch(0.72492 0.166374 48.688783)',
  600: 'oklch(0.674414 0.192429 42.148083)',
  650: 'oklch(0.613962 0.184358 39.794614)',
  700: 'oklch(0.55289 0.176309 37.423321)',
  750: 'oklch(0.492464 0.16713 35.422254)',
  800: 'oklch(0.432199 0.159379 33.02244)',
  850: 'oklch(0.357475 0.135212 32.07107)',
  900: 'oklch(0.281222 0.110671 30.651366)',
  950: 'oklch(0.206578 0.08477 29.23388)',
}
export const grey = {
  50: 'oklch(0.985104 0 0)',
  100: 'oklch(0.970151 0 0)',
  150: 'oklch(0.95514 0 0)',
  200: 'oklch(0.94007 0 0)',
  250: 'oklch(0.920652 0.002558 228.786818)',
  300: 'oklch(0.901624 0.003538 219.535738)',
  350: 'oklch(0.882025 0.006111 223.464254)',
  400: 'oklch(0.863097 0.007776 228.868893)',
  450: 'oklch(0.753634 0.008885 236.605307)',
  500: 'oklch(0.645222 0.009348 225.150438)',
  550: 'oklch(0.536704 0.009767 225.197358)',
  600: 'oklch(0.426427 0.011202 232.617199)',
  650: 'oklch(0.386365 0.01045 236.835687)',
  700: 'oklch(0.348204 0.010712 236.894097)',
  750: 'oklch(0.308978 0.011017 236.97265)',
  800: 'oklch(0.269413 0.01036 242.083865)',
  850: 'oklch(0.223572 0.008405 240.274391)',
  900: 'oklch(0.175228 0.006346 236.981786)',
  950: 'oklch(0.126543 0.006953 243.792325)',
}
